// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AsyncActionController from "./async_action_controller"
application.register("async-action", AsyncActionController)

import CampaignFormController from "./campaign_form_controller"
application.register("campaign-form", CampaignFormController)

import CheckboxesController from "./checkboxes_controller"
application.register("checkboxes", CheckboxesController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import DisableController from "./disable_controller"
application.register("disable", DisableController)

import FadeController from "./fade_controller"
application.register("fade", FadeController)

import FindOrCreateFieldsController from "./find_or_create_fields_controller"
application.register("find-or-create-fields", FindOrCreateFieldsController)

import InstructionsController from "./instructions_controller"
application.register("instructions", InstructionsController)

import LeaseDecoderController from "./lease_decoder_controller"
application.register("lease-decoder", LeaseDecoderController)

import CredsDecoderController from "./creds_decoder_controller"
application.register("creds-decoder", CredsDecoderController)

import LeaseRequestController from "./lease_request_controller"
application.register("lease-request", LeaseRequestController)

import LeaseResponseController from "./lease_response_controller"
application.register("lease-response", LeaseResponseController)

import LocalizedTimeController from "./localized_time_controller"
application.register("localized-time", LocalizedTimeController)

import MultipleFileInputController from "./multiple_file_input_controller"
application.register("multiple-file-input", MultipleFileInputController)

import PassphraseController from "./passphrase_controller"
application.register("passphrase", PassphraseController)

import StripeIssuingController from "./stripe_issuing_controller"
application.register("stripe-issuing", StripeIssuingController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import VisibilityController from "./visibility_controller"
application.register("visibility", VisibilityController)

import NestedForm from "./nested_form_controller"
application.register('nested-form', NestedForm)

import CollapseController from "./collapse_controller";
application.register("collapse", CollapseController);

import IssueTicketController from "./issue_ticket_controller"
application.register("issue-ticket", IssueTicketController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import TransactionSelectorController from "./transaction_selector_controller"
application.register("transaction-selector", TransactionSelectorController)

import DatePickerController from "./date_picker_controller"
application.register("date-picker", DatePickerController)

import DeviceSelectController from "./device_select_controller"
application.register("device-select", DeviceSelectController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import DrawerController from "./drawer_controller"
application.register("drawer", DrawerController)

import StepsToReproduceController from "./steps_to_reproduce_controller"
application.register("steps-to-reproduce", StepsToReproduceController)

import InlineSearchController from "./inline_search_controller"
application.register("inline-search", InlineSearchController)
